import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from './base.service';
import {BaseEntity} from '../base/BaseEntity';
import { Observable } from 'rxjs';




@Injectable()
export class AttributeTypeService extends BaseService<BaseEntity> {


  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string
  ) {
    super(http, rootUrl, 'AttributeType');
  }
}
